import { shallowEqual } from 'react-redux';

import { Card } from '@zillow/constellation-10';
import { LoadingText } from '@zg-rentals/loading-components';

import { useSelector } from '../../../../selectors/useSelector';

import { StyledSpacer } from '../../StyledComponents';
import GeneratedLeaseUpsell from '../GeneratedLeaseUpsell';

type Props = {
  isLoading?: boolean;
  isEligibleForGeneratedLease?: boolean;
  propertyState?: string;
};

const EmptyLeasesCardSimple = ({ isLoading = false, isEligibleForGeneratedLease = false, propertyState }: Props) => {
  const { isLeaseBuilderRestricted } = useSelector((state) => {
    return {
      isLeaseBuilderRestricted: state.properties.currentProperty.restrictions.isLeaseBuilderRestricted,
    };
  }, shallowEqual);

  const bodyContent = isLeaseBuilderRestricted ? 'Upload a lease' : 'Upload or create a lease';

  if (isEligibleForGeneratedLease) {
    return <GeneratedLeaseUpsell state={propertyState} />;
  }

  return (
    <Card data-testid="EmptyLeasesCardSimple" tone="neutral" elevated={false}>
      <LoadingText textStyle="body-bold" loadingWidth="100%" isLoading={isLoading}>
        Active leases will appear here
      </LoadingText>

      <StyledSpacer>
        <LoadingText textStyle="body-sm" loadingWidth="75%" isLoading={isLoading}>
          {bodyContent}
        </LoadingText>
      </StyledSpacer>
    </Card>
  );
};

export default EmptyLeasesCardSimple;
